import { Autocomplete, AutocompleteChangeDetails, AutocompleteChangeReason, Button, Collapse, Divider, Grid, Menu, MenuItem, TextField } from '@mui/material';
import _ from 'lodash';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { savedSearchSelector } from '../SavedSearch/reducers/SavedSearchReducer';
import { ComponentType } from '../SavedSearch/SavedSearch';
import { AutoCompleteFilterOptionState } from '../Tonnage/components/TonnageNameSelector';
import AreaModel from './models/AreaModel';
import PortModel from './models/PortModel';
import './PortSelector.scss';
import { portSelectorSelector, setAreas, setMasterAreas, setOpenModal, setPorts } from './reducers/PortSelectorReducer';
import PortSelectorApi from './api/PortSelectorApi';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';

interface PortMultipleSelectorProp {
    portValues?: PortModel[],
    areaValues?: AreaModel[],
    portLabel?: string,
    areaLabel?: string,
    onPortChange?: (port: PortModel[]) => void,
    onAreaChange?: (area: AreaModel[]) => void,
    useFreeText?: boolean,
    className?: string,
    onlyAreaMode?: boolean,
    disabled?: boolean,
    useAreaBookmark?: boolean
    hideArea?: boolean,
    hideOpposite?: boolean
}

const PortMultipleSelector: React.FunctionComponent<PortMultipleSelectorProp> = (props) => {
    const defaultPortValue: PortModel[] | undefined = props.portValues ? props.portValues : [];
    const defaultAreaValue: AreaModel[] | undefined = props.areaValues ? props.areaValues : [];

    let dispatch = useDispatch();
    let portSelectorData = useSelector(portSelectorSelector);
    let [portValues, setPortValues] = useState<PortModel[]>(defaultPortValue);
    let [areaValues, setAreaValues] = useState<AreaModel[]>(defaultAreaValue);
    const savedSearchData = useSelector(savedSearchSelector)
    const [open, setOpen] = useState(false);
    const filterLimit = 10;

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const openMenu = Boolean(anchorEl);

    useEffect(() => {
        let portValues = props.portValues ? props.portValues : [];
        setPortValues(portValues);
    }, [props.portValues])

    useEffect(() => {
        let areaValues = props.areaValues ? props.areaValues : [];
        setAreaValues(areaValues);
    }, [props.areaValues])

    const renderMenus = () => {
        let bookmarks = _.filter(savedSearchData.savedSearches, (savedSearch) => {
            return savedSearch.component == ComponentType.AreaBookmark;;
        });

        let menu = (
            <>
                {
                    _.map(bookmarks, (item => {
                        return <MenuItem
                            onClick={() => {
                                handleClose();

                                let areaValues = JSON.parse(item.queryJson) as AreaModel[];

                                if (props.onAreaChange) {
                                    props.onAreaChange(areaValues);
                                }

                                setAreaValues(areaValues);
                            }}
                        >
                            {item.name}
                        </MenuItem>
                    }))
                }
                <Divider />
                <MenuItem
                    onClick={() => {
                        dispatch(setOpenModal(true));
                        handleClose();
                    }}
                >
                    Manage Bookmark
                </MenuItem>
            </>
        )

        return menu;
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    return <>
        {
            portSelectorData.ports &&
            <Grid container>
                {
                    props.onlyAreaMode !== true &&
                    <Grid item xs={12}>
                        <Autocomplete
                            className={props.className ? props.className : ""}
                            disabled={props.disabled === true ? true : false}
                            freeSolo={props.useFreeText === true ? true : false}
                            multiple
                            value={portValues}
                            options={portSelectorData.ports}
                            renderInput={(params) => <TextField {...params} label={props.portLabel ? props.portLabel : "Port Name"} />}
                            getOptionLabel={(option: PortModel) => {
                                return option.name + " [" + option.area + "]";
                            }}
                            onChange={(event: SyntheticEvent<Element, Event>, values: Array<PortModel | string>, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<PortModel> | undefined) => {
                                let portValues = _.map(values, (value) => {
                                    return typeof value === "string" ? {
                                        name: value.toUpperCase(),
                                        positive: true
                                    } as PortModel : value as PortModel;
                                });

                                if (props.onPortChange) {
                                    props.onPortChange(portValues);
                                }

                                setPortValues(portValues);
                            }}
                            renderTags={(value: readonly PortModel[], getTagProps) => {
                                return value.map((option: PortModel, index: number) => {
                                    let isPositive = option.positive === undefined || option.positive === true;
                                    let className = isPositive ? "tag-filter-positive" : "tag-filter-negative";

                                    return <span className={"tag-filter " + className} >
                                        {
                                            !props.hideOpposite &&
                                            <i className="fa fa-refresh" aria-hidden="true"
                                                onClick={() => {
                                                    let items = [...portValues];
                                                    items[index] = {
                                                        ...items[index],
                                                        positive: !isPositive
                                                    }
                                                    setPortValues(items);

                                                    if (props.onPortChange) {
                                                        props.onPortChange(items);
                                                    }
                                                }} ></i>
                                        }
                                        &nbsp;
                                        {option.name}
                                        &nbsp;
                                        <i className="fa fa-times" aria-hidden="true"
                                            onClick={() => {
                                                let items = [...portValues];
                                                items.splice(index, 1);
                                                setPortValues(items);

                                                if (props.onPortChange) {
                                                    props.onPortChange(items);
                                                }
                                            }}
                                        ></i>
                                    </span>
                                })
                            }}
                            filterOptions={(options: Array<PortModel>, state: AutoCompleteFilterOptionState) => {
                                let inputValue = state.inputValue;

                                let searchResults = options.filter((option) => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
                                let searchResultsExcludeSelectedValue = _.filter(searchResults, (option) => {
                                    return _.findIndex(props.portValues, (value) => {
                                        return option.name.toLowerCase() === value.name.toLowerCase();
                                    }) < 0;
                                });

                                return _.take(searchResultsExcludeSelectedValue, filterLimit);
                            }}
                        />
                    </Grid>
                }

                {
                    !props.hideArea &&
                    <Grid item xs={12} className='port-multiple-selector-area-wrapper'>
                        <Autocomplete
                            className={props.className ? props.className : ""}
                            disabled={props.disabled === true ? true : false}
                            freeSolo={props.useFreeText === true ? true : false}
                            multiple
                            value={areaValues}
                            options={portSelectorData.areas}
                            renderInput={(params) => <TextField {...params} label={props.areaLabel ? props.areaLabel : "Area Name"} />}
                            getOptionLabel={(option: AreaModel) => {
                                return option.name;
                            }}
                            onChange={(event: SyntheticEvent<Element, Event>, values: Array<AreaModel | string>, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<AreaModel> | undefined) => {
                                let areaValues = _.map(values, (value) => {
                                    return typeof value === "string" ? {
                                        name: value.toUpperCase(),
                                        positive: true
                                    } as AreaModel : value as AreaModel;
                                });

                                if (props.onAreaChange) {
                                    props.onAreaChange(areaValues);
                                }

                                setAreaValues(areaValues);
                            }}
                            renderTags={(value: readonly AreaModel[], getTagProps) => {
                                return value.map((option: AreaModel, index: number) => {
                                    let isPositive = option.positive === undefined || option.positive === true;
                                    let className = isPositive ? "tag-filter-positive" : "tag-filter-negative";

                                    return <span className={"tag-filter " + className} >
                                        <i className="fa fa-refresh" aria-hidden="true"
                                            onClick={() => {
                                                let items = [...areaValues];
                                                items[index] = {
                                                    ...items[index],
                                                    positive: !isPositive
                                                }
                                                setAreaValues(items);

                                                if (props.onAreaChange) {
                                                    props.onAreaChange(items);
                                                }
                                            }} ></i> &nbsp;
                                        {option.name}
                                        &nbsp;
                                        <i className="fa fa-times" aria-hidden="true"
                                            onClick={() => {
                                                let items = [...areaValues];
                                                items.splice(index, 1);
                                                setAreaValues(items);

                                                if (props.onAreaChange) {
                                                    props.onAreaChange(items);
                                                }
                                            }}
                                        ></i>
                                    </span>
                                })
                            }}
                            filterOptions={(options: Array<AreaModel>, state: AutoCompleteFilterOptionState) => {
                                let inputValue = state.inputValue;

                                let searchResults = options.filter((option) => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
                                let searchResultsExcludeSelectedValue = _.filter(searchResults, (option) => {
                                    return _.findIndex(props.portValues, (value) => {
                                        return option.name.toLowerCase() === value.name.toLowerCase();
                                    }) < 0;
                                });

                                return searchResultsExcludeSelectedValue;
                            }}
                        />
                        {
                            props.useAreaBookmark === true &&
                            <div className='port-multiple-selector-bookmark-wrapper'>
                                <Button
                                    className='port-multiple-selector-bookmark'
                                    aria-controls={openMenu ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={openMenu ? 'true' : undefined}
                                    onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                        setAnchorEl(event.currentTarget);
                                    }}
                                >
                                    <i className="fa fa-bookmark" aria-hidden="true"></i>
                                </Button>
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={openMenu}
                                    onClose={handleClose}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                                >
                                    {
                                        renderMenus()
                                    }
                                </Menu>
                            </div>
                        }
                    </Grid>
                }
            </Grid>
        }
    </>;
};

export default PortMultipleSelector;